var _path, _path2, _path3, _path4, _circle, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoullete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 439,
    height: 439,
    viewBox: "0 0 439 439",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M329.062 109.688C343.467 124.092 354.893 141.192 362.689 160.013C370.484 178.833 374.496 199.004 374.496 219.375C374.496 239.746 370.484 259.917 362.689 278.737C354.893 297.558 343.467 314.658 329.062 329.063L219.375 219.375L329.062 109.688Z",
    fill: "#EF4123"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M329.062 329.062C314.658 343.467 297.558 354.893 278.737 362.689C259.917 370.484 239.746 374.497 219.375 374.497C199.004 374.497 178.833 370.484 160.013 362.689C141.192 354.893 124.092 343.467 109.688 329.062L219.375 219.375L329.062 329.062Z",
    fill: "#1CB0F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.687 109.688C124.092 95.2832 141.192 83.857 160.012 76.0614C178.833 68.2658 199.004 64.2535 219.375 64.2535C239.746 64.2535 259.917 68.2658 278.737 76.0614C297.558 83.857 314.658 95.2832 329.062 109.688L219.375 219.375L109.687 109.688Z",
    fill: "#58CC02"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.688 329.062C95.2832 314.658 83.857 297.558 76.0614 278.737C68.2658 259.917 64.2535 239.746 64.2535 219.375C64.2535 199.004 68.2658 178.833 76.0614 160.013C83.857 141.192 95.2832 124.092 109.688 109.687L219.375 219.375L109.688 329.062Z",
    fill: "#FFC800"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 219.775,
    cy: 219.115,
    r: 20.1997,
    transform: "rotate(-23.2812 219.775 219.115)",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M218.214 185.951L208.32 207.537C207.713 208.862 208.681 210.371 210.138 210.371H229.926C231.383 210.371 232.351 208.862 231.744 207.537L221.85 185.951C221.137 184.395 218.927 184.395 218.214 185.951Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoullete);
export default __webpack_public_path__ + "static/media/roullete.5f59194dec82cd76567bc604329ddb61.svg";
export { ForwardRef as ReactComponent };